import { Http } from '@gamiphy/http';
import { AppSurvey, UserSurvey, UserSurveyStatuses } from '@gamiphy/bl/survey';

export class SurveyApi {
  public static async getAppSurveys(): Promise<AppSurvey[]> {
    const response = await Http.get<GetAppSurveysResponse>({
      url: '/v2/surveys',
    });

    return response.data.surveys;
  }

  public static async getUserSurvey(appSurveyId: string): Promise<UserSurvey> {
    const response = await Http.get<GetUserSurveyResponse>({
      url: `/v2/user-surveys/surveys/${appSurveyId}`,
    });

    return response.data.userSurvey;
  }

  public static async answerQuestion(userSurveyId: string, questionId: string, answer: string | string[]): Promise<UserSurvey> {
    const response = await Http.patch<UpdateUserSurveyResponse>({
      url: `/v2/user-surveys/${userSurveyId}`,
      payload: {
        status: UserSurveyStatuses.draft,
        answers: [
          {
            question: questionId,
            answered: true,
            answer,
          },
        ],
      },
    });

    return response.data.userSurvey;
  }

  public static async submitSurvey(userSurveyId: string): Promise<UserSurvey> {
    const response = await Http.post<UpdateUserSurveyResponse>({
      url: `/v2/user-surveys/submit/${userSurveyId}`,
      payload: {
        status: UserSurveyStatuses.submitted,
      },
    });
    return response.data.userSurvey;
  }
}

export type GetAppSurveysResponse = {
  count: number,
  surveys: AppSurvey[] | []
}

export type GetUserSurveyResponse = {
  userSurvey: UserSurvey
}

export type UpdateUserSurveyResponse = {
  userSurvey: UserSurvey
}
